import { ENV } from "../env";
import { request, objectEntriesToUrlParams, objectEntriesToBServerJUrl } from "../utils";
import { graphicalAd, sasHtmlAd, bServerAd } from "../endpointUrl";
import { errorStatus, errorStatusToMessage } from "../utils/errorUtils";
import { filterAdResponse } from "../utils/adUtils";
import { mapTargetingParametersForSAS } from "../mapper/targetingParamsMapper";
import { Targeting, AdResponse, AdType } from "@digital-media/ad-model";

export const getGraphicalAd = (
  targeting: Targeting,
  numberOfAds = 1,
  type = AdType.HTML,
): Promise<AdResponse> => {

  switch (type) {
    case AdType.HTML:
      return getHTMLGraphicalAd(targeting, numberOfAds, type);
    case AdType.JSON:
      return getJSONGraphicalAd(targeting, numberOfAds, type);
    case AdType.JSON_B:
      return getJSONAdList(targeting, numberOfAds, type);
  }
};

const getJSONAdList = async (
    targeting: Targeting,
    numberOfAds = 1,
    type: AdType
): Promise<AdResponse> => {
  const paramsStr = objectEntriesToBServerJUrl({ ...mapTargetingParametersForSAS(targeting) }, numberOfAds);
  const response = await request(`${ENV.SAS}/${bServerAd}${paramsStr}`);

  if (errorStatus.includes(response.status)) {
    const body = await response.text();
    throw new Error(body || errorStatusToMessage[response.status]);
  } else if (response.status === 204) {
    return {};
  }

  const ads = await response.json();

  return { ads: ads, type: type };
}

const getJSONGraphicalAd = async (
  targeting: Targeting,
  numberOfAds = 1,
  type: AdType
): Promise<AdResponse> => {
  const paramsStr = objectEntriesToUrlParams({ ...targeting, numberOfAds });
  const response = await request(`${ENV.DMAS}/${graphicalAd}${paramsStr}`);

  if (errorStatus.includes(response.status)) {
    const body = await response.text();
    throw new Error(body || errorStatusToMessage[response.status]);
  } else if (response.status === 204) {
    return {};
  }

  const ads = await response.json();

  return { ads: ads.ads, type: type };
};

const getHTMLGraphicalAd = async (
  targeting: Targeting,
  numberOfAds = 1,
  type: AdType
): Promise<AdResponse> => {
  const paramsStr = objectEntriesToUrlParams({
    ...mapTargetingParametersForSAS(targeting),
  });
  const response = await request(`${ENV.SAS}/${sasHtmlAd}${paramsStr}`);

  if (errorStatus.includes(response.status)) {
    const body = await response.text();
    throw new Error(body || errorStatusToMessage[response.status]);
  } else if (response.status === 204) {
    return {};
  }

  const ads = await response.text();

  return { ads: filterAdResponse(ads), type: type };
};
